import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-internal-users-form',
  templateUrl: './internal-users-form.component.html',
  styleUrls: ['./internal-users-form.component.css']
})
export class InternalUsersFormComponent implements OnInit {
  data: any={};
  designations: any=[];
  d:any;
  u :any={};
  mode: any;
  Tr_Id: any;
  formSubmitted: boolean;
  dropdownSettings:any = {};
  Flag: string;
  temp:any=[];
  projectlist: any=[];
  project: any=[];
  projects: any=[];
  expanded: boolean = false;


  userprojectlist: any = [];
  constructor(private userService: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.Tr_Id = params['Tr_Id'];
    });
    
    if (this.Tr_Id != null && this.mode!=null) 
      this.GetInternalUser(this.Tr_Id);

      if(this.mode!='view'|| this.mode!='edit')
      {       
      this.GetAllUserDesignations();
      this.GetAllProjectsForDropdown();
      }


      this.dropdownSettings = {
        singleSelection: false,
        idField: 'Tr_Pro_Id',
        textField: 'Tr_Pro_Title',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 4,
        allowSearchFilter: false,
        maxHeight: 100,
      };
  }

  GetAllUserDesignations()
  {
    debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getAllUserDesignations();
      this.data.subscribe(
        (response:any) => {
          this.designations = response;
          console.log( "roles");
          console.log( this.designations);
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }

  onSubmit(internaluser: NgForm) {
    debugger;
    if (!internaluser.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      internaluser.value.User_Projectlist=this.userprojectlist;
      this.data = this.userService.SaveInternalUserDetails(internaluser.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Saved Successfully.', 'success');
          this.router.navigate(['/home/internal-users']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
           //this.errorHandler.HandlerError(error);
        });
    }
    else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
    }
  }

  GetInternalUser(Tr_Id) {
    debugger;
    if (Tr_Id != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getInternalUser(Tr_Id);
      this.data.subscribe(
        (response) => {
          this.u = response;
          this.userprojectlist = response.User_Projectlist;

          for (var i = 0; i < this.userprojectlist.length; i++) {
            for (var j = 0; j < this.projectlist.length; j++) {
              if (this.userprojectlist[i].Tr_Pro_Id == this.projectlist[j].Tr_Pro_Id)
                this.projectlist.splice(j, 1);
            }
          }   
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
  }

  Update(internaluser: NgForm) {
    debugger;
    if (!internaluser.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    internaluser.value.User_Projectlist=this.userprojectlist;
    this.data = this.userService.updateInternalUser(internaluser.value,this.Tr_Id);
    this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Updated Successfully!','success');
          this.router.navigate(['/home/internal-users']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          alert(error.error.Message);
        });
      }else{
        document.getElementById('loader-spinner').style.display = "none";
        swal('warning','Please fill all the mandatory fields!','warning');
        this.formSubmitted = true;
        }
  }



  GetAllProjectsForDropdown() {
    debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getAllProjectsForDropdown();
      this.data.subscribe(
        (response:any) => {
          this.projectlist = response;
          console.log(this.projectlist);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
    // }
  }




  //multiselect

  onItemSelect(item: any) {
    this.Flag='single';
      this.temp={
      Tr_Pro_Id: item.Tr_Pro_Id,
      Tr_Pro_Title: item.Tr_Pro_Title,
      }
    this.project.push(this.temp);
    console.log(item);
    console.log(this.Flag);
  }

  onSelectAll(items: any) {
    this.Flag='multiple';
    this.projects=items;
    console.log(items);
  }


  showCheckboxes() {
    let checkboxes = document.getElementById("checkboxes");
    if (!this.expanded) {
      checkboxes.style.display = "block";
      this.expanded = true;
    } else {
      checkboxes.style.display = "none";
      this.expanded = false;
    }
  }
  


  AddProjectList(item:any){
    debugger;

   //selectedprojectlist
    for(let i=0; i<this.projectlist.length; i++)
    {
      if(this.projectlist[i].Tr_Pro_Id==item)
      {
        var temp = {
          Tr_Pro_Id: this.projectlist[i].Tr_Pro_Id,
          Tr_Pro_Title: this.projectlist[i].Tr_Pro_Title,
      }
      //this.SelectedProject.push(temp);
      this.userprojectlist.push(temp);

      }
    }

    }


    RemoveProject(projectId: any) {
      debugger;
      for (var j = 0; j < this.userprojectlist.length; j++) {
        if (this.userprojectlist[j].Tr_Pro_Id == projectId) {
  
          let tem = {
            Tr_Pro_Id: this.userprojectlist[j].Tr_Pro_Id,
            Tr_Pro_Title: this.userprojectlist[j].Tr_Pro_Title,
            Tr_Inactive:'Y',
            Tr_Id :this.userprojectlist[j].Tr_Id,
          }
          this.projectlist.push(tem);
          this.userprojectlist[j].Tr_Inactive='Y';
          console.log(this.projectlist);
           // this.clientprojectlist.splice(j, 1);
        }
      }
    }


    Cancel(){
      this.u={};
    }
}



// WEBPACK FOOTER //
// ./src/app/masters/internal-users/internal-users-form/internal-users-form.component.ts